var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32821 4.32653C6.09915 2.55559 8.97041 2.55559 10.7413 4.32653C12.5123 6.09747 12.5123 8.96873 10.7413 10.7397C8.97041 12.5106 6.09914 12.5106 4.32821 10.7397C2.55726 8.96873 2.55727 6.09747 4.32821 4.32653ZM12.5091 2.55876C9.76186 -0.188491 5.30769 -0.188491 2.56044 2.55876C-0.186813 5.30601 -0.186813 9.76018 2.56044 12.5074C5.0061 14.9531 8.80448 15.2216 11.5471 13.3129L14.3698 16.1355C14.8579 16.6237 15.6494 16.6237 16.1376 16.1355C16.6257 15.6474 16.6257 14.8559 16.1376 14.3678L13.3148 11.5451C15.2232 8.80243 14.9547 5.0043 12.5091 2.55876Z",
    fill: "#00A3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e856475268f03a379637f2481f895500.svg";
export { ForwardRef as ReactComponent };